import { useState, useCallback } from "react";

export type MobileChartTab = "volume" | "count";
export type ChartType = "timeline" | "industry" | "phase" | "canton" | "gender";

type MobileChartTabs = Record<ChartType, MobileChartTab>;

export const useMobileChartTabs = () => {
  const [tabs, setTabs] = useState<MobileChartTabs>({
    timeline: "volume",
    industry: "volume",
    phase: "volume",
    canton: "volume",
    gender: "volume",
  });

  const setTab = useCallback((chart: ChartType, value: MobileChartTab) => {
    setTabs((prev) => ({ ...prev, [chart]: value }));
  }, []);

  return {
    tabs,
    setTab,
  } as const;
};
